import axios from "axios";

export const adminApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function apiError(err, fallback = "Valami nem sikerült. Kérlek, próbáld újra.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return "Kérlek, ellenőrizd a megadott adatokat.";
  return fallback;
}

export const PROGRAM_STATUS = {
  published: { label: "Meghirdetve", tone: "petrol" },
  soon: { label: "Hamarosan", tone: "gold" },
  draft: { label: "Piszkozat", tone: "muted" },
  archived: { label: "Archív", tone: "muted" },
};

export const REG_STATUS = {
  new: "Új jelentkezés",
  payment_info_sent: "Fizetési információ elküldve",
  paid: "Befizetve / véglegesítve",
  cancelled: "Lemondva",
  waitlist: "Várólista",
};

export const FORMAT_LABEL = { online: "Online", personal: "Személyes" };

export function formatDateTime(value) {
  if (!value) return "";
  const d = new Date(value);
  return d.toLocaleString("hu-HU", { year: "numeric", month: "long", day: "numeric", weekday: "long", hour: "2-digit", minute: "2-digit" });
}

export function formatHuf(n) {
  return `${Number(n || 0).toLocaleString("hu-HU").replace(/\s/g, ".")} Ft`;
}
